import { render, staticRenderFns } from "./HITextArea.vue?vue&type=template&id=4cec1536&"
import script from "./HITextArea.vue?vue&type=script&lang=js&"
export * from "./HITextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports